if (document.body.classList.contains('hazte-jueg')) {
    $(document).on('click', '.button-step', function () {
        let direction_data = $(this).data('direction'); // на случай необходимости появления кнопки "назад" при вводе данных. Это дата-атрибут кнопки button-step
        let direction = ((direction_data === null || direction_data === undefined) ? true : direction_data); // next by default
        let current_panel = $(this).parents('.main-step'); //

        // check fields first

        if (direction) {
            if (validate_form_items(current_panel)) {
                $('.breadcrumbs .active').removeClass('active').next().addClass('active'); // move breadcrumb on next step
                $(current_panel).removeClass('registration-visible').next().addClass('registration-visible'); // show next step panel
                $('.step-flex').addClass('hidden');
            }
        } else {
            if ($(current_panel).prev().hasClass('main-step')) {
                $('.breadcrumbs .active').removeClass('active').prev().addClass('active');
                $(current_panel).removeClass('registration-visible').prev().addClass('registration-visible');
                $('.step-flex').removeClass('hidden');
            }
        }

        $('html, body').animate({scrollTop: 300}, 'slow');
    })

    $(document).on('keypress', function (e) {
        if (e.which === 13) {
            let current_panel = $('.main-step.registration-visible');
            if (current_panel.next().hasClass('main-step')) {
                e.preventDefault();
                if (validate_form_items(current_panel)) {
                    $('.breadcrumb .active').removeClass('active').next().addClass('active'); // move breadcrumb on next step
                    $(current_panel).removeClass('registration-visible').next().addClass('registration-visible'); // show next step panel
                }
                $('html, body').animate({scrollTop: 300}, 'slow');
            }
        }
    });

    $('#project-reg-form').on('click', 'button[type="submit"]', function (e) {
        e.preventDefault();
        if (validate_form_items('#project-reg-form')) {
            $('#project-reg-form').submit();
        }
    })

    $('#company-reg-form').on('submit', function (e) {
        e.preventDefault();
        if (validate_form_items('#company-reg-form')) {
            $('#company-reg-form').submit();
        }
    })

    function validate_form_items(dom_node) {
        let is_validated = true;
        $(dom_node).find('input').each(function () {

            if ($(this).is(':visible')) {
                $(this)[0].addEventListener('invalid', suppress_invalid)
                let is_valid = $(this)[0].checkValidity();
                $(this).toggleClass('error', !is_valid);
                $(this)[0].removeEventListener('invalid', suppress_invalid)
                $('.error-block-top').removeClass('hidden');

                if (!is_valid) {
                    is_validated = false;
                    // console.error( 'Field invalid', $(this)[0] );
                }
            }
        });
        return is_validated;
    }

    function suppress_invalid(e) {
        e.preventDefault();
    }

    $(document).on('click', '#persona', function () {
        $('.persona-form').addClass('active');
        $('.organization-form').removeClass('active');
    });
    $(document).on('click', '#organization', function () {
        $('.persona-form').removeClass('active');
        $('.organization-form').addClass('active');
    });
    $(document).on('click', '.button-step', function () {
        // $('.step-flex').addClass('hidden');
    });
    $(document).on('click', '#step-flex-into-1', function () {
        $('.step-3__block-bank').addClass('active');
        $('.step-3__block-card').removeClass('active');
    });
    $(document).on('click', '#step-flex-into-2', function () {
        $('.step-3__block-bank').removeClass('active');
        $('.step-3__block-card').addClass('active');
    });
}
$(document).on('click', '#step-flex-into-3', function () {
    $('.step-3__block-bank').addClass('active');
    $('.step-3__block-card').removeClass('active');
});
$(document).on('click', '#step-flex-into-4', function () {
    $('.step-3__block-bank').removeClass('active');
    $('.step-3__block-card').addClass('active');
});

